function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.875 9.53906C21.875 9.83203 21.7461 10.1016 21.5117 10.3242L13.7305 18.0938C13.4961 18.3164 13.25 18.4219 12.9688 18.4219C12.3945 18.4219 11.9375 18 11.9375 17.4141C11.9375 17.1328 12.043 16.8516 12.2305 16.6758L14.8555 14.0039L18.8047 10.4062L15.9688 10.582H1.14453C0.535156 10.582 0.113281 10.1484 0.113281 9.53906C0.113281 8.92969 0.535156 8.49609 1.14453 8.49609H15.9688L18.793 8.67188L14.8555 5.07422L12.2305 2.40234C12.043 2.21484 11.9375 1.94531 11.9375 1.66406C11.9375 1.07812 12.3945 0.65625 12.9688 0.65625C13.25 0.65625 13.4961 0.75 13.7539 1.00781L21.5117 8.75391C21.7461 8.97656 21.875 9.24609 21.875 9.53906Z",
  fill: "#6D28D9"
});

function SvgRightArrowPurple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowPurple);
export default __webpack_public_path__ + "static/media/right-arrow-purple.0fe7d0fe.svg";
export { ForwardRef as ReactComponent };